import type {
  MetricsTrendsResponse,
  TrendDataPoint,
} from "../../../../../shared/api/types";

export const transformTrendsData = (
  data: MetricsTrendsResponse | undefined,
  metrics: string[]
): Array<Record<string, string | number | null>> => {
  if (!data?.data?.trend || data.data.trend.length === 0) return [];

  return data.data.trend.map((point: TrendDataPoint) => {
    const transformed: Record<string, string | number | null> = {
      period: point.period,
      label: point.label,
    };

    metrics.forEach((metric) => {
      const value = point[metric];
      if (value !== null && value !== undefined) {
        const numValue = typeof value === "number" ? value : Number(value);
        transformed[metric] = Math.round(numValue * 10) / 10;
      } else {
        transformed[metric] = null;
      }
    });

    return transformed;
  });
};
